/*
 * Copyright (c) 2019. Sonrai Analytics Ltd.
 * Developed by Deva Sen., Ryan Duffy & Warren Dowey
 */

import { Injectable } from '@angular/core';
@Injectable()
export class ValidateService {
  constructor() {}
  /**
   *  Deva Sen.
   *
   *  validateRegister
   *
   *  Check if the fields are empty for form validation
   *
   * @param user of type any to take all the user's fiekds for validation
   *
   * @returns boolean: of whether or not the user passed this validation
   */
  validateRegister(user) {
    if (
      user.name === undefined ||
      user.username === undefined ||
      user.email === undefined ||
      user.role === undefined ||
      user.password === undefined
    ) {
      return false;
    } else {
      return true;
    }
  }
  /**
   *  Deva Sen.
   *
   *  validateName
   *
   *  Check if the fields are valid syntax
   *
   * @param name of type any to take user's entered name
   *
   * @returns boolean: of whether or not the user passed this validation
   */
  validateName(name) {
    const nreg = /(?=^.{2,10}$)^[a-zA-Z]+$/;
    return nreg.test(name);
  }
  /**
   *  Deva Sen.
   *
   *  validateEmail
   *
   *  Check if email has correct syntax
   *
   * @param email of type any to take user's entered email
   *
   * @returns boolean: of whether or not the user passed this validation
   */
  validateEmail(email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    // Will return true/false depending on if or not the email is valid
    return re.test(email);
  }
  /**
   *  Deva Sen.
   *
   *  validateUsername
   *
   *  Check if username has valid syntax
   *
   * @param email of type any to take user's entered username
   *
   * @returns boolean: of whether or not the user passed this validation
   */
  validateUsername(username) {
    const ureg = /(?=^.{3,10}$)^[a-zA-Z][a-zA-Z0-9]*[._-]?[a-zA-Z0-9]+$/;
    return ureg.test(username);
  }
  /**
   *  Deva Sen.
   *
   *  validatePassword
   *
   *  check if password has valid syntax
   *
   * @param email of type any to take user's entered password
   *
   * @returns boolean: of whether or not the user passed this validation
   */
  validatePassword(password) {
    const preg = /^.*(?=.{7,15})(?=.*\d)(?=.*[a-zA-Z]).*$/;
    return preg.test(password);
  }
  /**
   *  Deva Sen.
   *
   *  validatePassword
   *
   *  Check if passwords match on form for repeat
   *
   * @param email of type any to take user's entered passwords
   *
   * @returns boolean: of whether or not the user passed this validation
   */
  matchPasswords(password, re_password) {
    if (password !== re_password) {
      return false;
    } else {
      return true;
    }
  }
}
